import TermsAgreement from "./terms-agreement";

export default TermsAgreement;
